import { createSlice } from "@reduxjs/toolkit";
import contractPricingReducers from "./reducers";

export const initialState = {
    priceIndex: {
        0: {
            backPrices: [
                {
                    displayPrice: undefined,
                    stake: undefined
                }
            ],
            layPrices: [
                {
                    displayPrice: undefined,
                    stake: undefined
                }
            ]
        }
    },
    marketIndex: {
        0: {
            status: undefined,
            deleted: undefined
        }
    },
    matchedAmountIndex: {
        0: {
            againstSideAmount: undefined,
            forSideAmount: undefined
        }
    }
};

export const contractPricingSlice = createSlice({
    name: "contractPricing",
    initialState,
    reducers: contractPricingReducers
});

export const { setPriceIndex, setMarketIndex, setMatchedAmount, resetStore } = contractPricingSlice.actions;
export default contractPricingSlice.reducer;
